module.exports = __webpack_public_path__ + "static/media/d9a489d905875c05e7c5be895e557ccf3ff46f5b-25x24.62b5065a.png";